'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var EmailAppIcon = function EmailAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 500 500",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }), React__default["default"].createElement("defs", null, React__default["default"].createElement("linearGradient", {
    x1: "31.9322755%",
    y1: "18.1464695%",
    x2: "100%",
    y2: "58.5043919%",
    id: "linearGradient-1"
  }, React__default["default"].createElement("stop", {
    stopColor: "#BDBDBD",
    offset: "0%"
  }), React__default["default"].createElement("stop", {
    stopColor: "#BDBDBD",
    stopOpacity: "0",
    offset: "100%"
  }))), React__default["default"].createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default["default"].createElement("g", {
    id: "Email-Marketing"
  }, React__default["default"].createElement("g", {
    id: "Group-2",
    transform: "translate(-1.000000, 79.000000)"
  }, React__default["default"].createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 26.000000)"
  }, React__default["default"].createElement("rect", {
    id: "Rectangle-4",
    fill: "#EEEEEE",
    x: "1",
    y: "0",
    width: "480",
    height: "317",
    rx: "40"
  }), React__default["default"].createElement("path", {
    d: "M41,0 L442.617297,7.81597009e-14 C463.815479,3.66101237e-14 481,17.1845213 481,38.3827027 L39.4,317 L39.4,317 C18.1922656,317 1,299.807734 1,278.6 L1,40 C1,17.90861 18.90861,4.05812251e-15 41,0 Z",
    id: "Rectangle-4-Copy-2",
    fill: "#E0E0E0"
  }), React__default["default"].createElement("path", {
    d: "M41,0 L442.617297,7.81597009e-14 C463.815479,3.66101237e-14 481,17.1845213 481,38.3827027 L39.4,317 L39.4,317 C18.1922656,317 1,299.807734 1,278.6 L1,40 C1,17.90861 18.90861,4.05812251e-15 41,0 Z",
    id: "Rectangle-4-Copy-5",
    fill: "#E0E0E0",
    transform: "translate(241.000000, 158.500000) scale(-1, 1) translate(-241.000000, -158.500000) "
  }), React__default["default"].createElement("path", {
    d: "M39.3827027,0 L441,0 C463.09139,-4.05812251e-15 481,17.90861 481,40 L481,277 C481,299.09139 463.09139,317 441,317 L307.560625,317 L1,38.3827027 L1,38.3827027 C1,17.1845213 18.1845213,3.89404274e-15 39.3827027,0 Z",
    id: "Rectangle-4-Copy-3",
    fillOpacity: "0.3",
    fill: "url(#linearGradient-1)"
  }), React__default["default"].createElement("path", {
    d: "M38.1313905,0 L442.86861,6.39488462e-14 C463.927995,2.26713165e-14 481,17.072005 481,38.1313905 L240.5,209 L0,38.1313905 L0,38.1313905 C-2.5790309e-15,17.072005 17.072005,1.09739737e-14 38.1313905,7.10542736e-15 Z",
    id: "Rectangle-4-Copy",
    fill: "#F5F5F5"
  })), React__default["default"].createElement("circle", {
    id: "Oval-3",
    fill: "#F44336",
    cx: "441.5",
    cy: "62.5",
    r: "59.5"
  }), React__default["default"].createElement("text", {
    id: "@",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: "80",
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, React__default["default"].createElement("tspan", {
    x: "406.011719",
    y: "84"
  }, "@"))))));
};

var EmailAppIcon$1 = iconStyles()(EmailAppIcon);

module.exports = EmailAppIcon$1;
